import { CAPSULE, FIELD, LASER, VIEW } from '../core/config.js';

/**
 * Falling capsules and laser bolts. These carry position and motion only;
 * collision and effects are handled by the systems layer.
 */

export function createCapsule(type, x, y) {
  return {
    type,
    x,
    y,
    w: CAPSULE.w,
    h: CAPSULE.h,
    /** Drives the barrel-roll animation the arcade capsules had. */
    spin: 0,
    dead: false,
  };
}

export function updateCapsules(capsules, dt) {
  for (let i = capsules.length - 1; i >= 0; i -= 1) {
    const capsule = capsules[i];
    capsule.y += CAPSULE.fallSpeed * dt;
    capsule.spin += dt * 3.4;
    if (capsule.dead || capsule.y - capsule.h > VIEW.H) capsules.splice(i, 1);
  }
}

export function capsuleHitsPaddle(capsule, paddle) {
  const halfW = capsule.w / 2;
  const halfH = capsule.h / 2;
  return (
    capsule.x + halfW > paddle.cx - paddle.w / 2 &&
    capsule.x - halfW < paddle.cx + paddle.w / 2 &&
    capsule.y + halfH > paddle.y &&
    capsule.y - halfH < paddle.y + paddle.h
  );
}

export function createBolt(x, y) {
  return { x, y, w: LASER.w, h: LASER.h, dead: false };
}

export function updateBolts(bolts, dt) {
  for (let i = bolts.length - 1; i >= 0; i -= 1) {
    const bolt = bolts[i];
    bolt.y -= LASER.speed * dt;
    if (bolt.dead || bolt.y + bolt.h < FIELD.top) bolts.splice(i, 1);
  }
}

/** Slow purple orbs DOH spits at the paddle. */
export function createDohShot(x, y, vx, vy, size) {
  return { x, y, vx, vy, r: size / 2, life: 0, dead: false };
}

export function updateDohShots(shots, dt) {
  for (let i = shots.length - 1; i >= 0; i -= 1) {
    const shot = shots[i];
    shot.x += shot.vx * dt;
    shot.y += shot.vy * dt;
    shot.life += dt;
    if (shot.x < FIELD.left || shot.x > FIELD.right) shot.vx *= -1;
    if (shot.dead || shot.y - shot.r > VIEW.H) shots.splice(i, 1);
  }
}

export function shotHitsPaddle(shot, paddle) {
  return (
    shot.x + shot.r > paddle.cx - paddle.w / 2 &&
    shot.x - shot.r < paddle.cx + paddle.w / 2 &&
    shot.y + shot.r > paddle.y &&
    shot.y - shot.r < paddle.y + paddle.h
  );
}
